module.exports = __webpack_public_path__ + "media/images/color_admin_v3/transparent/black-0.7-67fd3b3d799fc20c46d3aeba0846a184.png";